module.exports = __webpack_public_path__ + "img/join-02-3.32395be8.png";